<template>
    <h3 class="text-lg uppercase font-semibold"><slot /></h3>
</template>

<script>
export default {}
</script>
